import { configureStore } from '@reduxjs/toolkit';
import { reducer } from '@invision/core';

/**
 * Redux Store Configuration
 * Following customercare2 patterns - using core reducer for session state compatibility
 * Most authentication state managed by React Query + Context
 */
export const store = configureStore({
  reducer: {
    core: reducer
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
